import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../services/http.service';
import { Router } from "@angular/router";
import { URLUtils } from '../urlUtils';
import {
  buildLoginDevicePayload,
  DeviceSyncLoginPayload,
  getOrCreateDeviceId
} from 'src/app/device.utils';
import { Utils } from '../utils';
import { environment } from '../../environments/environment';
import { ViewChild, ElementRef } from '@angular/core';
import { SessionService } from '../services/session_service';
import { Analytics, setUserId, setUserProperties } from '@angular/fire/analytics';
import { MarketplaceVisibilityService } from '../services/marketplace-visibility.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
	
	@ViewChild('otp1') otp1Input!: ElementRef;
	@ViewChild('identifierInput') identifierInput!: ElementRef;
	submitted = false;
	firmsShow = true;
	firmsData:any = { firms: []}
	// showPassword = false;
	showMultiLogin: boolean = false;
	showResetForm: boolean = false;
	showLoginForm: boolean = true;
	showForgotForm: boolean = false;
	resetData: any = {};
	// myForm: any = FormGroup;
  	msg: string = ""
	product = environment.product;
	showTC = false;
	//tag = 'Lauditor';
    msgError: boolean = false; 

	// showOTPForm: boolean = false; 
	otpForm: any = FormGroup;
	otpSubmitted: boolean = false;
	otpSent: boolean = false;
	otpRequestInProgress: boolean = false;
	resendDisabled: boolean = false;
	resendTimer: number = 60;
	resendInterval: any;
	otpDigits: string[] = ['', '', '', '', '', ''];
	usePasswordLogin = false;
	showPassword = false;
	

	constructor(private formBuilder: FormBuilder,
				private router: Router,
				private httpservice: HttpService,
				private sessionService: SessionService,
				private analytics: Analytics,
				private marketplaceService: MarketplaceVisibilityService,
				private toast: ToastrService){ }
	
	ngOnInit() {

		// localStorage.removeItem("TOKEN")
		// Ensure a persistent device_id exists from the moment the login page loads.
		// This mirrors WhatsApp Web — the browser identity is established before login.
		getOrCreateDeviceId();
		const alert_msg:any=localStorage.getItem('alert_msg')
		if (localStorage.getItem('alert_msg') != null) {
			this.msg = alert_msg
			localStorage.removeItem('alert_msg')
		}
		else if (localStorage.getItem('error_alert_msg') != null) {
			const error_alert_msg:any=localStorage.getItem('error_alert_msg')
			this.msg = error_alert_msg
			localStorage.removeItem('error_alert_msg')
		}
		
		/*
		this.myForm = this.formBuilder.group({
      		email:['', [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]],
			password: ['', Validators.required],
			plan: [this.product]
		})
		*/

		this.otpForm = this.formBuilder.group({
			identifier: ['', [Validators.required, this.emailOrMobileValidator]],
			otp: ['', [Validators.pattern(/^[0-9]{6}$/)]],
			password: [''],
			plan: [this.product]
		})

		const email = localStorage.getItem('login_email');
		const mobile = localStorage.getItem('login_mobile');
		const identifier = email || mobile;

		if (identifier) {
			this.otpForm.get('identifier')?.setValue(identifier);

			// Optional: remove after patching
			localStorage.removeItem('login_email');
			localStorage.removeItem('login_mobile');
		}
	}

	ngOnDestroy() {
		// Clean up interval on component destroy
		if (this.resendInterval) {
			clearInterval(this.resendInterval);
		}
	}

	// get f() { return this.myForm.controls; }
	get otpF() { return this.otpForm.controls; }

	invalidIdentifierValidator(control: any) {
		const value = control.value;

		if (!value) return null;

		const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
		const isMobile = /^[0-9]{10}$/.test(value);

		return isEmail || isMobile ? null : { invalidIdentifier: true };
	}

	toggleLoginMode() {
		this.usePasswordLogin = !this.usePasswordLogin;
		this.otpSent = false;
		this.msg = '';
		this.otpSubmitted = false;
		this.otpDigits = ['', '', '', '', '', ''];
		this.stopResendTimer();

		const identifierControl = this.otpForm.get('identifier');
		// Always re-enable first — the field may have been disabled by requestOTP()
		identifierControl?.enable();
		//identifierControl?.reset();

		// Clear OTP validators when leaving OTP mode
		const otpControl = this.otpForm.get('otp');
		otpControl?.clearValidators();
		otpControl?.reset();
		otpControl?.updateValueAndValidity();

		// if (this.usePasswordLogin) {
		// 	identifierControl?.setValidators([
		// 		Validators.required,
		// 		Validators.email
		// 	]);
		// } 
		if (this.usePasswordLogin) {
			identifierControl?.setValidators([
				Validators.required,
				this.emailOrMobileValidator
			]);
		}
		else {
			identifierControl?.setValidators([
				Validators.required,
				this.invalidIdentifierValidator
			]);
		}

		identifierControl?.updateValueAndValidity();

		// Focus input AFTER UI updates
		setTimeout(() => {
			this.identifierInput?.nativeElement.focus();
		}, 0);
	}

	removeLeadingSpace(event: any) {
		const value = event.target.value;

		if (value.startsWith(' ')) {
			event.target.value = value.trimStart();
			this.otpForm.get('identifier')?.setValue(event.target.value);
		}
	}

	togglePasswordVisibility() {
		this.showPassword = !this.showPassword;
	}
	emailOrMobileValidator(control: any) {
		if (!control.value) return null;

		const value = control.value.trim();

		const emailRegex =
			/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		const mobileRegex =
			/^[6-9][0-9]{9}$/; // Indian mobile format

		if (emailRegex.test(value) || mobileRegex.test(value)) {
			return null;
		}

		return { invalidIdentifier: true };
	}

	// OTP Box Navigation Methods
	onOtpKeyUp(event: any, index: number, nextInput: any) {
		const input = event.target;
		const value = input.value;

		// Allow only numbers
		if (value && !/^\d$/.test(value)) {
			this.otpDigits[index - 1] = '';
			return;
		}

		// Move to next input if value entered
		if (value && nextInput) {
			nextInput.focus();
		}

		// Handle backspace
		if (event.key === 'Backspace' && !value && index > 1) {
			const previousInput = event.target.previousElementSibling;
			if (previousInput) {
				previousInput.focus();
			}
		}

		// Update the form control with combined OTP
		this.updateOtpFormControl();
	}

	onOtpPaste(event: ClipboardEvent) {
		event.preventDefault();
		const pastedData = event.clipboardData?.getData('text') || '';
		const digits = pastedData.replace(/\D/g, '').slice(0, 6).split('');
		
		this.otpDigits = [...digits, ...Array(6 - digits.length).fill('')];
		this.updateOtpFormControl();
	}

	updateOtpFormControl() {
		const otpValue = this.otpDigits.join('');
		this.otpForm.patchValue({ otp: otpValue });
	}

	cancelOTPLogin() {
		this.msg = "";
		this.otpSubmitted = false;
		this.otpSent = false;
		this.otpRequestInProgress = false;
		this.otpDigits = ['', '', '', '', '', ''];
		
		// Reset the form and re-enable the identifier field
		this.otpForm.reset({ plan: this.product });
		this.otpForm.get('identifier').enable();
		this.otpForm.get('otp').clearValidators();
		this.otpForm.get('otp').updateValueAndValidity();
		
		this.stopResendTimer();
	}

	// Handle OTP form submission
	// onOTPSubmit() {
	// 	this.otpSubmitted = true;
	// 	this.msg = "";

	// 	if (this.otpForm.get('identifier').invalid) {
	// 		return;
	// 	}

	// 	if (!this.otpSent) {
	// 		// Request OTP
	// 		this.requestOTP();
	// 	} else {
	// 		// Verify OTP
	// 		if (this.otpForm.get('otp').invalid) {
	// 			return;
	// 		}
	// 		this.verifyOTP();
	// 	}
	// }

	onOTPSubmit() {
		this.otpSubmitted = true;
		this.msg = "";

		let identifier = this.otpForm.get('identifier')?.value?.trim();
		// const identifier = this.otpForm.get('identifier')?.value;
	    // console.log('identifier', identifier)

		if (!identifier) return;

		// LOGIN HERE
		if (this.usePasswordLogin) {

			// if (!identifier.includes('@')) {
			// 	this.msg = 'Please enter a valid email address';
			// 	this.msgError = true;
			// 	return;
			// }

			if (this.otpForm.get('password')?.invalid) {
				return;
			}

			const password = this.otpForm.get('password')?.value;
			

			const payload: any = {
				password,
				plan: this.product,
				device_id: localStorage.getItem('device_id') || ''
			};
			console.log('--payload', payload);
			
			
			if (identifier.includes('@')) {
				payload.email = identifier.toLowerCase();
			} else {
				payload.mobile = identifier;
			}


			this.otpRequestInProgress = true;

			const loginService =
				this.product === 'indiamp'
					? this.httpservice.sendIMPostRequest(URLUtils.login, payload)
					: this.httpservice.sendPostRequest(URLUtils.v2login, payload, "", true);

			loginService.subscribe(
				(resp: any) => {
					console.log('login resp', resp);
					this.otpRequestInProgress = false;

					if (!resp.error) {
						this.initSession(resp); // success login
					} 
					else if (resp.error == true) {
						this.httpservice.sendPostRequest(URLUtils.login, payload).subscribe(
							(resp: any) => {
								// console.log('login errTrue resp', resp);
								// console.log('payload resp', payload);

								if (!resp['error']) {
									// console.log('check resp:', resp['data'], resp['data']['groups'])
									if (resp['data']['plan'].toLowerCase() == Utils.productName) {
										localStorage.setItem('user_groups', JSON.stringify(resp['data']['groups'])); //Storing groups in localStorage
										// localStorage.setItem('is_active', JSON.stringify(resp['data']['subscription']['is_active']));
										this.initSession(resp)
									} else {
										this.msg = "Account not found";
										this.msgError = true;
									}
								} 
								else {
									if (resp.hasOwnProperty("firms")) {
										let firms = Object.entries(resp['firms'][Utils.productName])
										if (firms.length == 0) {
											this.msg = "Account not found";
											this.msgError = true;
										}
										else if (firms.length > 1) {
											this.firmsData['firms'] = resp['firms'][Utils.productName]
											this.firmsData['email'] = this.otpForm.value['identifier']
											this.showFirmsList()
										} else {
											let value = resp['firms'][Utils.productName][0]
											var payload: any;
											payload['userid'] = value["id"]
											payload['password'] = this.otpForm.value['password']
											payload['email'] = this.otpForm.value['identifier']
											this.initSession(payload)
										}
									} 
									else {
										if (resp['plan'] != undefined && resp['plan'] != Utils.productName) {
											this.msg = "Account not found";
											this.msgError = true;
										} else {
											if (this.redirectToRegisterIfUserNotFound(identifier, resp['msg'])) {
												return;
											}
											this.msg = resp['msg'];
											this.msgError = true; // "Invalid email/password" case
										}
									}
								}
							}
						)
					}
					else {
						if (this.redirectToRegisterIfUserNotFound(identifier, resp.msg)) {
							return;
						}
						this.msg = resp.msg;
						this.msgError = true;
					}
				},
				() => {
					this.otpRequestInProgress = false;
					this.msg = 'Error logging in. Please try again.';
					this.msgError = true;
				}
			);

			return; 
		}

		// Existing OTP flow (unchanged)
		if (this.otpForm.get('identifier').invalid) {
			return;
		}

		if (!this.otpSent) {
			this.requestOTP();
		} else {
			if (this.otpForm.get('otp').invalid) {
				return;
			}
			this.verifyOTP();
		}

		this.httpservice.getCity().subscribe(res => {
			console.log(res.city);
			localStorage.setItem('city', res.city);
		});
	}

	// Request OTP from server
	requestOTP() {
		this.otpRequestInProgress = true;

		const identifier = this.otpForm.getRawValue()['identifier']?.trim();
		const isEmail = identifier.includes('@');
		const payload: any = { plan: this.product,device_id: localStorage.getItem('device_id') || '' };

		if (isEmail) {
			payload.email = identifier.toLowerCase();
			localStorage.setItem('user_email', identifier.toLowerCase());
			localStorage.setItem('login_identifier_type', 'email');
		} else {
			payload.mobile = identifier;
			localStorage.setItem('user_mobile', identifier);
			localStorage.setItem('login_identifier_type', 'mobile');
		}

		const loginService =
			this.product === 'indiamp'
			? this.httpservice.sendIMPostRequest(URLUtils.login, payload)
			: this.httpservice.sendPostRequest(URLUtils.v2login, payload);

		loginService.subscribe(
			(resp: any) => {
				this.otpRequestInProgress = false;

				if (resp.otp_sent) {
					this.otpSent = true;
					this.msg = resp.msg;
					this.msgError = resp.error === true; // Set based on resp.error

					this.otpForm.get('identifier').disable();
					this.otpSubmitted = false;

					this.otpForm.get('otp').setValidators([
						Validators.required,
						Validators.pattern(/^[0-9]{6}$/)
					]);
					this.otpForm.get('otp').updateValueAndValidity();

					this.startResendTimer();
					// Added focus
					setTimeout(() => {
						this.otp1Input?.nativeElement.focus();
					}, 0);
				} else {
					if (this.redirectToRegisterIfUserNotFound(identifier, resp.msg)) {
						return;
					}
					this.msg = resp.msg;
					this.msgError = resp.error === true; // Set based on resp.error
				}
			},
			() => {
				this.otpRequestInProgress = false;
				this.msg = 'Error sending OTP. Please try again.';
				this.msgError = true;
			}
		);
	}

	/**
	 * If the login API confirms this email/mobile isn't a registered user,
	 * send them straight to the registration screen with the value
	 * pre-filled, instead of just leaving them stuck on an error they
	 * can't act on. Returns true if a redirect happened.
	 */
	private redirectToRegisterIfUserNotFound(identifier: string, apiMsg: any): boolean {
		const isUserNotFound = typeof apiMsg === 'string' && apiMsg.trim().toLowerCase() === 'user not found';
		if (!isUserNotFound || !identifier) {
			return false;
		}

		const isEmail = identifier.includes('@');
		this.toast.info(
			isEmail
				? `The email ${identifier} isn't registered yet. Please create an account to continue.`
				: `The mobile number ${identifier} isn't registered yet. Please create an account to continue.`
		);
		this.router.navigate(['/registerotp'], {
			queryParams: isEmail ? { email: identifier } : { mobile: identifier }
		});
		return true;
	}

	// Verify OTP
	verifyOTP() {
	this.otpRequestInProgress = true;

	const identifier = this.otpForm.get('identifier')?.value;
	const otp = this.otpForm.value['otp'];

	const payload: any = {
		otp,
		plan: this.product,
		device_id: localStorage.getItem('device_id') || ''
	};

	if (identifier.includes('@')) {
		payload.email = identifier.toLowerCase();
	} else {
		payload.mobile = identifier;
	}

	const loginService =
		this.product === 'indiamp'
		? this.httpservice.sendIMPostRequest(URLUtils.login, payload)
		: this.httpservice.sendPostRequest(URLUtils.v2login, payload, "", true);

	loginService.subscribe(
		(resp: any) => {
		this.otpRequestInProgress = false;

		if (!resp.error) {
			this.initSession(resp);
		} else {
			this.msg = resp.msg;
			this.msgError = resp.error === true; // Set based on resp.error
		}
		},
		() => {
		this.otpRequestInProgress = false;
		this.msg = 'Error verifying OTP. Please try again.';
		this.msgError = true;
		}
	);
	}

	// Resend OTP
	resendOTP() {
		if (this.resendDisabled) {
			return;
		}

		this.otpSubmitted = false;
		this.otpForm.get('otp').reset();
		this.otpDigits = ['', '', '', '', '', ''];
		this.requestOTP();
	}

	// Start resend timer
	startResendTimer() {
		this.resendDisabled = true;
		this.resendTimer = 60;

		this.resendInterval = setInterval(() => {
			this.resendTimer--;
			if (this.resendTimer <= 0) {
				this.stopResendTimer();
			}
		}, 1000);
	}

	// Stop resend timer
	stopResendTimer() {
		if (this.resendInterval) {
			clearInterval(this.resendInterval);
			this.resendInterval = null;
		}
		this.resendDisabled = false;
		this.resendTimer = 60;
	}

	initSession(resp:any) {
		// console.log('init resp',resp)
		// debugger
		if (resp['data']['account_status'] != null) {
			if (resp['data']['account_status'] == 'disable') {
				this.msg = "Your acccount has disabled, Please contact admin"
				return
			}
		}
		
		if (resp['data']['password_mode'] != null) {
			if (resp['data']['password_mode'] == 'reset' && this.usePasswordLogin) {
				console.log('Please reset your password.')
				this.resetData = resp['data'];
				this.resetData['enteredPwd'] = this.otpForm.value['password'];
				this.showResetForm = true;
				this.showMultiLogin = false
				this.showLoginForm = false
				return
			}
		}

		
		const plan = resp['data']['plan']?.toLowerCase();
		const product = Utils.productName;

		if (resp['data']['plan'].toLowerCase() == Utils.productName) {
			localStorage.setItem('plan', resp['data']['plan'].toLowerCase())
			localStorage.setItem('isPaidSub', JSON.stringify(resp['data']['subscription']['is_active'])); //Storing groups in localStorage
		    localStorage.setItem('features', JSON.stringify(resp['data']['subscription']['features']));
			localStorage.setItem('plan', resp['data']['subscription']['plan']);

		}
		else if (plan === 'india-marketplace' && product === 'indiamp') {
			localStorage.setItem('plan', resp['data']['plan'].toLowerCase())
		}
		else {
			this.msg = "Account not found"
			return
		}

		if (resp['data']['id'] != null) {
			localStorage.setItem('user_id', resp['data']['id'])
			localStorage.setItem('user_email', resp['data']['user_email'])
			this.syncDevice(resp['data']['id']);
		}
		else {
			localStorage.removeItem('user_id')
		}
		this.httpservice.setToken(resp['token']);
		localStorage.setItem('TOKEN', resp['data']['access_token'])
		localStorage.setItem('REFRESH_TOKEN', resp['data']['refresh_token'])
		localStorage.setItem('name', resp['data']['name'])
		localStorage.setItem('role', resp['data']['role'])
		localStorage.setItem('prof_id', resp['data']['pk'])
		localStorage.setItem('profuid', resp['data']['profuid'])
		localStorage.setItem('isadmin', resp['data']['admin'])
		localStorage.setItem('jid', resp['data']['uid'])
		localStorage.setItem('firm_name', resp['data']['firm_name'])
		localStorage.setItem('is_marketplace', resp['data']['is_marketplace'])
		localStorage.setItem('marketplace_id', resp['data']['marketplace_id'])
		// Seed the "Available for Consultations" toggle from this login response
		// every time — is_marketplace_listed is authoritative, not is_marketplace.
		this.marketplaceService.initFromLoginResponse(resp['data']['is_marketplace_listed'])
		localStorage.setItem('category', resp['data']['category'])
		//console.log(resp['data']['requiresTermsAcceptance'])
		localStorage.setItem('requiresTermsAcceptance', JSON.stringify(resp['data']['requiresTermsAcceptance']))
		
		localStorage.setItem('user_allowed', JSON.stringify(resp['data'].user_allowed));
		localStorage.setItem('AAM_email', JSON.stringify(resp['data'].email)); 
		// localStorage.setItem('is_active', JSON.stringify(res?.data?.email)); 

		// if (resp['data']['regswatch_agreement'] != undefined && !resp['data']['regswatch_agreement']) {
		// 	this.openAgreement()
		// 	//console.log(resp['data'])
		// 	return
		// }
		setUserId(this.analytics, localStorage.getItem('user_id'));
		setUserProperties(this.analytics, {
			env: environment.appEnv
		});
		// this.sessionService.init();
		if (resp['data']['firms'] && Array.isArray(resp['data']['firms'])) {
  // store canonical array under 'user_firms'
  localStorage.setItem('user_firms', JSON.stringify(resp['data']['firms']));
} else {
  // defensively clear old data if none present
  localStorage.removeItem('user_firms');
}
		// localStorage.setItem('user_id', resp['data']['user_id'])
		this.router.navigate(['/grid'])
		    

	}

	 openAgreement(): void {
    this.showTC = true;
  }
  closeAgreement(): void {
    this.showTC = false;
  }
  agree(): void {
    this.showTC = false;
	this.httpservice.sendPostRequest(URLUtils.aggrementPdfFile, {}).subscribe((res:any) => {
	  if (res.error == false) {
		this.router.navigate(['/grid']);
	  }

	})
  }
  
	/* 
	 onSubmit() {
		this.submitted = true
		this.msg = ""
	 	if (this.myForm.invalid) { return; }
		this.callLoginWebService(this.myForm.value)
	}

	callLoginWebService(data:any) {
		// console.log('login data',data)
		// console.log('prod',this.product)
		const email = this.myForm.value['email']?.trim().toLowerCase();
		// console.log('email',email)

		let payload = {
			...this.myForm.value,
			email
		}
		// console.log('payload',payload)
		localStorage.setItem('user_email', JSON.stringify(email)); //Storing user email in localStorage

		if (this.product == 'indiamp') {
			// console.log('IndiaMP product login')
			this.httpservice.sendIMPostRequest(URLUtils.login, payload).subscribe(
				(resp: any) => {
					if (!resp['error']) {
						const plan = resp['data']['plan']?.toLowerCase();
						const product = Utils.productName;

						if (plan === 'india-marketplace' && product === 'indiamp') {
							localStorage.setItem('user_groups', JSON.stringify(resp['data']['groups'])); //Storing groups in localStorage
							// localStorage.setItem('is_active', JSON.stringify(resp['data']['subscription']['is_active']));
							this.initSession(resp)
						} else {
							this.msg = "Account not found"
						}
					} else {
						if (resp.hasOwnProperty("firms")) {
							let firms = Object.entries(resp['firms'][Utils.productName])
							if (firms.length == 0) {
								this.msg = "Account not found"
							}
							else if (firms.length > 1) {
								this.firmsData['firms'] = resp['firms'][Utils.productName]
								this.firmsData['email'] = this.myForm.value['email']
								this.showFirmsList()
							} else {
								let value = resp['firms'][Utils.productName][0]
								var payload: any;
								payload['userid'] = value["id"]
								payload['password'] = this.myForm.value['password']
								payload['email'] = this.myForm.value['email']
								this.callLoginWebService(payload)
							}
						} else {
							if (resp['plan'] != undefined && resp['plan'] != Utils.productName)
								this.msg = "Account not found"
							else
								this.msg = resp['msg']
						}
					}
				}
			)
		}
		else {
			// console.log('Other product login')
			this.httpservice.sendPostRequest(URLUtils.login, payload).subscribe(
				(resp: any) => {
					if (!resp['error']) {
						// console.log('check resp:', resp['data'], resp['data']['groups'])
						if (resp['data']['plan'].toLowerCase() == Utils.productName) {
							localStorage.setItem('user_groups', JSON.stringify(resp['data']['groups'])); //Storing groups in localStorage
							// localStorage.setItem('is_active', JSON.stringify(resp['data']['subscription']['is_active']));
							this.initSession(resp)
						} else {
							this.msg = "Account not found"
						}
					} else {
						if (resp.hasOwnProperty("firms")) {
							let firms = Object.entries(resp['firms'][Utils.productName])
							if (firms.length == 0) {
								this.msg = "Account not found"
							}
							else if (firms.length > 1) {
								this.firmsData['firms'] = resp['firms'][Utils.productName]
								this.firmsData['email'] = this.myForm.value['email']
								this.showFirmsList()
							} else {
								let value = resp['firms'][Utils.productName][0]
								var payload: any;
								payload['userid'] = value["id"]
								payload['password'] = this.myForm.value['password']
								payload['email'] = this.myForm.value['email']
								this.callLoginWebService(payload)
							}
						} else {
							if (resp['plan'] != undefined && resp['plan'] != Utils.productName)
								this.msg = "Account not found"
							else
								this.msg = resp['msg']
						}
					}
				}
			)
		}
	 }
	 */

  // -----------------------------------------------------------------------
  // Device sync — login flow (user_id now known)
  //
  // Called exactly once per successful login, inside initSession(), after
  // user_id has been written to localStorage.  This single convergence point
  // covers ALL login paths: OTP, password, and multi-firm.
  //
  // The backend can use this call to:
  //   – record last_active timestamp
  //   – display the "Active Devices" list
  //   – flag suspicious logins (new OS / timezone)
  //   – support "Logout from this device" / device revocation
  // -----------------------------------------------------------------------
  syncDevice(userId: string): void {
    const payload: DeviceSyncLoginPayload = buildLoginDevicePayload(userId, this.product);

    this.httpservice.sendOtpPostRequest(URLUtils.deviceSync, payload).subscribe(
      (_resp: any) => {
        // Device registered — no UI action needed
        console.debug('[DeviceSync] login sync OK', payload.device_id, 'user', userId);
      },
      (_error: any) => {
        // Non-fatal — session is already established; don't block the user
        console.debug('[DeviceSync] login sync failed (non-fatal)');
      }
    );
  }

	showFirmsList() {
		this.showLoginForm = false
		this.showMultiLogin = true
		this.showResetForm = false
	}

	forgotPwd(){
		this.showLoginForm = false
		this.showForgotForm = true
		this.msg = ""
		this.msgError = false;
	}

	onChildEvent(msg: any){
		if(msg["msg"] == 'firm-close') {
			this.showMultiLogin = false
			this.showResetForm = false
			this.showLoginForm = true
		}
		if(msg["msg"] == 'firm-done') {
			
		}
		
		if(msg["msg"] == 'resetpwd'){
			this.resetData = msg['data']
			this.showResetForm = true
			this.showMultiLogin = false
			this.showLoginForm = false
		}
		if(msg["msg"] == 'reset-success'){
			this.showLoginForm = true
			this.showResetForm = false
			this.showMultiLogin = false
			this.msg = "Password reset successful! Please login"
			this.msgError = false;
		}
		
		if(msg['msg'] == 'forgot-success'){
			this.showLoginForm = true
			this.showForgotForm = false
			this.msg = "Please check your email for temporary password."
			this.msgError = false;
		}
		if(msg['msg'] == 'forgot-cancel'){
			this.showLoginForm = true
			this.showForgotForm = false
		}
		
	}
}